export var upgradeImageProtocol = function upgradeImageProtocol(src) {
  /**
   * Check if src is not a string or starts with 'data' or 'http'
   */
  if (src !== null && src !== void 0 && src.startsWith('data') || !(src !== null && src !== void 0 && src.startsWith('//')) || !(src !== null && src !== void 0 && src.startsWith('/'))) {
    /**
     * Return the src as is as it could be a StaticRequire or StaticImageData
     */
    return src;
  }
  /**
   * If src starts with '/' or any other case, prepend 'https:' to src
   */


  return "https:".concat(src);
};